<template>
  <div>
    <v-main>
      <div>
        <center>
          <v-card color="#385F73" dark max-width="auto">
            <!-- <v-container fluid> -->
            <v-card-actions>
              <v-list-item class="grow">
                <v-list-item-avatar size="80" color="grey darken-3">
                  <v-img
                    class="elevation-6"
                    alt=""
                    :src="profile.empImageUrl"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-h6">
                    {{ profile.empFull_NameTH }}
                  </v-list-item-title>
                  <v-list-item-title class="text-h6">
                    {{ profile.empCode }}
                  </v-list-item-title>
                  <v-list-item-subtitle>{{
                    profile.positionName
                  }}</v-list-item-subtitle>
                  <v-list-item-subtitle
                    >{{ profile.masDepartmentName }} :
                    {{ profile.masBranchName }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-card-actions>
            <!-- </v-container> -->
          </v-card>

          <v-card>
            <v-img
              @click="Home()"
              :lazy-src="imageUrlBack"
              max-height="30"
              max-width="100"
              :src="imageUrlBack"
            ></v-img>

            <v-sheet tile height="54" class="d-flex">
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-icon color="#871B12" size="30" @click="searchShiftData()"
                >mdi-calendar-search</v-icon
              >
            </v-sheet>
          </v-card>
          <!-- ตารางวันทำงาน -->

          <v-row>
            <v-col cols="12">
              <v-card class="pa-2" outline title>
                <v-progress-linear
                  color="deep-purple accent-4"
                  :active="!dataReady"
                  :indeterminate="!dataReady"
                  absolute
                  height="6"
                ></v-progress-linear>
                <v-sheet height="500">
                  <v-calendar :start="startdate" ref="calendar" >
                    <template v-slot:day-label="{ day }">
                      <span style="font-size: 10px !important">{{ day }}</span>
                    </template>
                    <template v-slot:day="{ date }">
                      <v-sheet
                        v-if="
                          events.filter((el) => {
                            return el.start == date;
                          }).length > 0
                        "
                        :color="
                          events.filter((el) => {
                            return el.start == date;
                          })[0].color
                        "
                        dark
                      >
                        <span style="font-size: 10px !important">{{
                          events.filter((el) => {
                            return el.start == date;
                          })[0].name
                        }}</span>
                      </v-sheet>
                    </template>
                  </v-calendar>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
          <!-- </v-row> -->
        </center>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment' // แปลง date
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'

export default {
  components: {},
  name: 'Info',
  data () {
    return {
      imageUrlBack: '',
      dataReady: false,
      PK: '',
      path: '/shift_import/', // Path Model
      // Menu Config
      value: '',
      month: '',
      year: '',
      startdate: this.getDateTh(),
      shift: [],
      profile: [],
      dataItem: [],
      dataShiftItem: [],
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      masDepartmentCode: '',
      events: []
    }
  },
  async mounted () {
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.dataReady = false
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    // await this.getDataEmp()
    await this.searchShiftData()
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    async searchShiftData () {
      let data = JSON.parse(localStorage.getItem('liff_info'))
      this.month = this.month !== '' ? this.month : this.getMonthTh()
      this.year = this.year !== '' ? this.year : moment().format('YYYY')
      this.dataReady = false
      this.dataShiftItem = []
      await axios
        .get(
          this.DNS_IP + '/employee/getEmp_by_empCode?empCode=' + data.empCode +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year
        )
        .then(async (response) => {
          console.log(response)

          this.dataReady = true
          this.dataShiftItem = response.data
          // เพิ่มตัวแปร events
          this.events = []

          // กะทำงาน
          this.dataShiftItem.forEach((elmShift) => {
            var dateFormat =
                  elmShift.shiftYear +
                  '-' +
                  (parseInt(elmShift.shiftMonth) + 100).toString().substr(1, 2) +
                  '-' +
                  (parseInt(elmShift.shiftDay) + 100).toString().substr(1, 2)
            var date = dateFormat
            this.startdate = date
            this.events.push({
              name: elmShift.masShiftTypeName,
              start: date,
              color: elmShift.masShiftTypeColor
            })
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          this.$swal('ไม่มีข้อมูล', 'ไม่พบข้อมูลช่วงเวลาที่ท่านเลือก', 'error')
        })
    },
    async getDataEmp () {
      let data = JSON.parse(localStorage.getItem('liff_info'))

      this.dataReady = false
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee/getEmp_by_empCode?empCode=" + data.empCode
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Liff/ShiftWorkEmp.vue